import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SnackBarService } from '../../../shared/services/snack-bar/snack-bar.service';
import { AppUpdateService } from './app-update.service';

export function provideAppUpdate(): EnvironmentProviders {
  return makeEnvironmentProviders([AppUpdateService, SnackBarService]);
}
